export default __webpack_public_path__ + "static/media/clock_icon.47599d31.svg";